<div class="row" *ngIf="aboutSection">
  <div class="col s12 l4 x3"><h2 class="header">{{aboutSection.title}}</h2></div>
  <div class="col s12 l8 x9 content" [innerHTML]="aboutSection.content">
  </div>
</div>
